import React from 'react'
import getQueryVariable from '/app/src/lib/urlparser'
import {Flex} from '/app/src/component'
import AssignedConversation from '../../Conversation/Assigned'


class SearchTicketRightPanel extends React.Component {
    constructor(props){
        super(props);
        this._setRoom = this._setRoom.bind(this);
        const room = getQueryVariable(this.props.location.search, 'room');

        this.state = {
            room: room
        }
    }

    _setRoom() {
        const room = getQueryVariable(this.props.location.search, 'room');
        if (room !== this.state.room){
            this.setState({
                room: room
            })
        }
    }

    componentDidMount() {
        this._setRoom();
    }

    componentDidUpdate() {
        this._setRoom();
    }

    render() {
        const room = this.state.room;
        if (room)
            return <AssignedConversation room={room} />
        else
            return <Flex grow column center>
                <h1> {'Inget ärende vald.'} </h1>
            </Flex>
    }
}
export default SearchTicketRightPanel;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Search/Ticket/index.js